<template>
  <b-card v-if="isLoaded" class="col-8 card-zone">
    <text-input :required="true" name="zone-title" :placeholder="$t('zone.name.placeholder')"
                v-model="formData.name"
    />

    <multiselect :placeholder="$t('zone.select.placeholder')"
                 name="search-cp"
                 ref="search-cp"
                 track-by="id"
                 v-model="formData.cities"
                 :options="options"
                 :loading="isFetching"
                 :multiple="true"
                 :taggable="false"
                 :searchable="true"
                 :internal-search="false"
                 :close-on-select="false"
                 :clear-on-select="false"
                 :preserve-search="true"
                 :show-no-results="true"
                 selected-label=""
                 select-label=""
                 deselect-label=""
                 @search-change="search"
    >
      <template slot="option" slot-scope="{ option }">
        <span class="option__desc">
          <div class="option__title">
            {{ option.cp }} {{ option.text }}
          </div>
        </span>
      </template>

      <template slot="tag" slot-scope="{ option, remove }">
        <span class="multiselect__tag">
          <span class="option__desc">
            <div class="option__title">
              {{ option.text }}
            </div>
          </span>
          <i class="multiselect__tag-icon" @click="remove(option)"></i>
        </span>
      </template>

      <template slot="noResult">
        {{ $t('_no_result_found') }}
      </template>

      <template slot="noOptions">
        {{ $t('zone.select.empty') }}
      </template>
    </multiselect>
    <div class="row justify-content-end buttons-bloc">
      <router-link :to="{ name: 'zone_list' }"
                   class="btn orange-white centered-button"
      >
        {{ success ? 'Liste' : $t('_cancel') }}
      </router-link>
      <button v-if="!success" :disabled="submitDisabled" @click="submit"
              class="btn orange-white "
      >
        {{ $t('form.submit') }}
      </button>
      <router-link v-else-if="id" :to="{ name: 'zone_show', params: { id: id } }"
                   class="btn orange-white "
      >
        {{ $t('zone.show.button') }}
      </router-link>
    </div>
    <b-col cols="12" md="3" class="buttons-bloc">
      <b-alert :show="alert.show" :variant="alert.variant" dismissible>
        {{ alert.msg }}
      </b-alert>
    </b-col>
  </b-card>
</template>

<script>
import { cancelAxiosRequest } from '@/utils/apiUtils'
import CommonApi from '@/api/commonApi'
import FormSubmitter from '@/api/formSubmitter'
import textInput from "@/components/frontoffice/form/baseInput/text"
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  components: {
    textInput
  },

  props: {
    value: Array
  },

  data () {
    return {
      isLoaded: false,
      commonApi: new CommonApi(),
      isFetching: false,
      id: this.$route.params.id,
      options: [],
      formData: {
        name: "",
        cities: []
      },
      success: null,
      alert: {
        msg: "",
        variant: "",
        show: false
      }
    }
  },

  created () {
    this.isLoaded = true

    if (this.id) {
      this.commonApi.getZone(this.id)
      .then( resp => {
        this.formData = {
          name: resp.data.data.name,
          cities: resp.data.data.cities
        }

      })
      .finally( this.isLoaded = true )
    }
  },

  methods: {
    search (search) {
      cancelAxiosRequest()
      this.options = []

      // min 2 characters
      if (search.length < 2) return

      this.isFetching = true

      this.commonApi.searchCityOrPostCode(search)
      .then( resp => this.options = resp.data.data )
      .then( () => this.isFetching = false )
    },

    submit () {
      this.alert.show = false

      let submitter = new FormSubmitter(this.$route.name === 'zone_create' ? 'zone_add' : 'zone_edit')
      submitter.submitRequest(this.id || null, this.formData)
      .then( resp => {
        this.alert.show = true

        if (resp.data.success) {
          this.id = resp.data.data.id
          this.dealSuccess()
        } else {
          this.dealFailure(resp.data.errors)
        }
      })
    },

    dealSuccess () {
      this.success = true
      let tkey = 'zone.alert'
      let isEdit = this.$route.name.includes('edit')
      this.alert.msg = this.$t(
        `${tkey}.msg`,
        {
          name: this.formData.name,
          verb: this.$t(`${tkey}.verb.${this.isEdit ? 'updated' : 'created'}`)
        }
      )
    },

    dealFailure (error) {
      this.success = false
      this.alert.msg = error
    },

    cancel () {
      this.$router.push("zone_list")
    }
  },

  computed: {
    submitDisabled () {
      return !this.formData.cities.length || !this.formData.name.length
    }
  },

  watch: {
    success (success) {
      this.alert.variant = success ? 'success' : 'danger'
    }
  }
}
</script>
